import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TagComponent } from '@components/atoms/tag/tag.component';
import { BankingPartnerStore } from '@stores/partner.store';

@Component({
  selector: 'hlp-partner-tag',
  imports: [TagComponent],
  template: `
    <hlp-tag
      [backgroundColor]="partner()?.backgroundBtnColor ?? 'var(--color-primary)'"
      [customClasses]="customClasses()"
      [label]="partner()?.label ?? partnerId()"
      innerClass="partner"
    />
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerTagComponent {
  readonly bankingPartnerStore = inject(BankingPartnerStore);
  readonly customClasses = input<string>();
  readonly partnerId = input.required<string>();
  readonly partner = computed(() => this.bankingPartnerStore.partnerFromId(this.partnerId()));
}
